export const getCartRulesMetaobjects = /* GraphQL */ `
  query getCartRulesMetaobjects($type: String!, $first: Int!, $after: String) {
    metaobjects(type: $type, first: $first, after: $after) {
      edges {
        node {
          id
          handle
          type
          updatedAt
          fields {
            key
            value
            type
            reference {
              ... on ProductVariant {
                id
              }
            }
            references(first: 10) {
              edges {
                node {
                  ... on ProductVariant {
                    id
                  }
                }
              }
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const getCartRuleMetaobjectByHandle = /* GraphQL */ `
  query getCartRuleMetaobjectByHandle($handle: String!, $type: String!) {
    metaobject(handle: { handle: $handle, type: $type }) {
      id
      handle
      type
      updatedAt
      fields {
        key
        value
        type
        reference {
          ... on ProductVariant {
            id
          }
        }
        references(first: 10) {
          edges {
            node {
              ... on ProductVariant {
                id
              }
            }
          }
        }
      }
    }
  }
`;
